import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import pluralize from 'pluralize';
import Fa from 'react-fontawesome';
import NumberFormat from 'react-number-format';
import {
  FormGroup, InputGroup,
  Tooltip, OverlayTrigger,
} from 'react-bootstrap';
import { getUserCurrentOrganization } from '../../modules/Auth/AuthReducer';


class MinMaxForm extends Component {
  constructor(props) {
    super(props);
    const { searchCriteria } = props;
    this.state = {
      minError: false,
      maxError: false,
      values: searchCriteria.values ? [...searchCriteria.values] : [],
    };
    this.handleMinValueChange = this.handleMinValueChange.bind(this);
    this.handleMaxValueChange = this.handleMaxValueChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const currentValues = this.state.values || [];
    const nextValues = nextProps.searchCriteria?.values || [];
    if (currentValues[0] !== nextValues[0] || currentValues[1] !== nextValues[1]) {
      this.setState({ values: [...nextValues] });
    }
  }


  handleBlur() {
    // const { searchCriteria } = this.props;
    // this.setState({ values: searchCriteria.values || [] });
  }



  handleMinValueChange(r) {
    const { floatValue } = r;
    const { disabled } = this.props;
    if (disabled) {
      return;
    }
    const { values } = this.state;
    const maxValue = values[1] || null;
    let minValue = Number.isNaN(floatValue) ? null : floatValue;

    if (typeof minValue === 'undefined') {
      minValue = null;
    }
    let minError = false;
    if (minValue > maxValue && minValue !== null && maxValue !== null) {
      minError = true;
    }
    const newValues = [...values];

    newValues[0] = minValue;

    if (maxValue === null || minValue === null || (minValue <= maxValue)) {
      const updatedValues = [...values];
      if (minValue === null) {
        updatedValues[0] = null;
      } else {
        updatedValues[0] = minValue;
      }
      if (!minError) {
        this.props.onUpdate(...updatedValues);
      }
    }
    this.setState({ minError, maxError: false, values: newValues });
  }

  handleMaxValueChange({ floatValue }) {
    const { disabled } = this.props;
    if (disabled) {
      return;
    }
    const { values } = this.state;
    const minValue = values[0] || null;
    let maxValue = Number.isNaN(floatValue) ? null : floatValue;
    if (typeof maxValue === 'undefined') {
      maxValue = null;
    }
    
    let maxError = false;
    if (minValue > maxValue && minValue !== null && maxValue !== null) {
      maxError = true;
    }
    
    const newValues = [...values];
    newValues[1] = maxValue;

    if (maxValue === null || minValue === null || (minValue <= maxValue)) {
      const updatedValues = [...values];
      if (maxValue === null) {
        updatedValues[1] = null;
      } else {
        updatedValues[1] = maxValue;
      }
      if (!maxError) {
        this.props.onUpdate(...updatedValues);
      }
    }
    this.setState({ minError: false, maxError, values: newValues });
  }

  renderField(type = 'min') {
    const {
      disabled, searchCriteria, organization,
      suffixIsUnit, suffixMin, suffixMax,
    } = this.props;

    const { maxError, minError, values } = this.state;
    const { filter } = searchCriteria;
    const isMin = type === 'min';
    const label = isMin ? 'minimum' : 'maximum';
    let value = isMin ? values[0] : values[1];

    if (value === null) {
      value = '';
    }
    const hasError = isMin ? minError : maxError;

    const metaType = (filter.meta || {}).type;

    let unit = '';
    let prefix = '';
    let decimalScale = 2;

    if (metaType === 'currency') {
      prefix = '$';
      if (organization) {
        unit = organization.currency_suffix;
        prefix = organization.currency_symbol;
      }
      decimalScale = 0;
    } else if (filter.tag === 'tenure') {
      unit = 'months';
      decimalScale = 0;
    } else if (filter.tag === 'opportunityAge' || filter.tag === 'dayPush') {
      unit = 'days';
      decimalScale = 0;
    } else if (filter.tag === 'pushFrequency') {
      unit = 'times';
      decimalScale = 0;
    } else if (metaType === 'percent') {
      unit = ' %';
    } else if (filter._id === 'Gong__Gong_Call__c/Gong__Call_Duration_sec__c') {
      decimalScale = 0;
      unit = 'second';
    } else if (metaType === 'int') {
      decimalScale = 0;
      unit = type === 'min' ? suffixMin : suffixMax;
    }
    if (unit && metaType !== 'currency' && suffixIsUnit) {
      unit = ` ${pluralize(unit, value)}`;
    }
    const validationState = hasError ? 'error' : null;
    const errorMsg = isMin ? 'Must be less than maximum value' : 'Must be greater than minimum value';

    const tip = hasError ? (
      <Tooltip id={`${filter._id}-${(isMin ? 'min' : 'max')}`}>
        <div>{errorMsg}</div>
      </Tooltip>
    ) : null;

    const handler = isMin ? this.handleMinValueChange : this.handleMaxValueChange;
    return (
      <FormGroup validationState={validationState}>
        <InputGroup bsSize="sm">
          <InputGroup.Addon>
            {(isMin ? 'from' : 'to')}
          </InputGroup.Addon>
          <NumberFormat
            className="form-control"
            thousandSeparator
            prefix={prefix}
            value={value}
            disabled={disabled}
            decimalScale={decimalScale}
            placeholder={label}
            onValueChange={handler}
            onBlur={this.handleBlur}
          />
          {unit !== null && <InputGroup.Addon>{unit}</InputGroup.Addon>}
          <InputGroup.Addon>
            {!hasError && <Fa name="exclamation-triangle" className="invisible" />}
            {hasError &&
              <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="top" overlay={tip}>
                <Fa name="exclamation-triangle" style={{ cursor: 'help' }} className="text-danger" />
              </OverlayTrigger>
            }
          </InputGroup.Addon>
        </InputGroup>
      </FormGroup>
    );
  }

  render() {
    const cls = 'col-sm-6';
    return (
      <div>
        <div className="row">
          <div className={cls}>
            {this.renderField('min')}
          </div>
          <div className={cls}>
            {this.renderField('max')}
          </div>
        </div>
      </div>
    );
  }
}

MinMaxForm.propTypes = {
  disabled: PropTypes.bool,
  searchCriteria: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    filter: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      tag: PropTypes.string.isRequired,
    }),
    values: PropTypes.arrayOf(PropTypes.number),
    control_type: PropTypes.string,
  }),
  onUpdate: PropTypes.func.isRequired,
  organization: PropTypes.shape({}),
  suffixIsUnit: PropTypes.bool,
  suffixMin: PropTypes.string,
  suffixMax: PropTypes.string,
};
MinMaxForm.defaultProps = {
  searchCriteria: null,
  disabled: false,
  organization: null,
  suffixIsUnit: true,
  suffixMin: null,
  suffixMax: null,
};
function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}
export default connect(mapStateToProps)(MinMaxForm);